<template>
  <div :class="_.page">
    <slot />

    <div
      v-if="theme.hasCartButton || theme.hasOrderButton || theme.hasTopButton"
      :class="_.actions"
    >
      <div
        v-if="theme.hasCartButton"
        v-track="{
          name: '购物车',
          id: `${pageId}-cart`,
        }"
        :class="_.item"
        @click="handleCartClick"
      >
        <img :src="theme.cartButtonImage" :class="_.icon" />
        <div v-if="cartCount" :class="_.badge">
          {{ 99 >= cartCount ? cartCount : '99+' }}
        </div>
      </div>
      <div
        v-if="theme.hasOrderButton"
        v-track="{
          name: '订单',
          id: `${pageId}-order`,
        }"
        :class="_.item"
        @click="handleOrderClick"
      >
        <img :src="theme.orderButtonImage" :class="_.icon" />
      </div>
      <div
        v-if="theme.hasTopButton"
        v-track="{
          name: '返回顶部',
          id: `${pageId}-backTop`,
        }"
        :class="_.item"
        @click="handleBackTopClick"
      >
        <img :src="theme.topButtonImage" :class="_.icon" />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    provide() {
      return {
        pageTheme: this.theme,
      }
    },

    data: () => ({
      cartCount: 9,
    }),

    mounted() {
      if (this.$dmbcApi?.getCartCount && this.theme.hasCartButton) {
        this.$dmbcApi
          .getCartCount()
          .then(cartCount => (this.cartCount = cartCount))
      }
    },

    methods: {
      handleCartClick() {
        this.$router.push('/cart/index')
      },
      handleOrderClick() {
        this.$dmbcResourceClick(this.theme.orderIndexUrl)
      },
      handleBackTopClick() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
    },
  })
</script>

<style lang="scss" module="_">
  .page {
    width: 100%;
    line-height: normal;
  }

  .actions {
    position: fixed;
    right: 7px;
    bottom: 90px;
    z-index: 10;
    font-size: 0;

    .item {
      position: relative;

      .icon {
        width: 46px;
        height: 46px;
      }

      .badge {
        position: absolute;
        top: 0px;
        right: 0px;
        background: #ff3b30;
        border-radius: 1000px;
        border: 1px solid #ffffff;
        font-size: 12px;
        color: #ffffff;
        padding: 2px 4px;
        line-height: 1;
        min-width: 20px;
        min-height: 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &:active {
        filter: contrast(0.9);
      }

      + .item {
        margin-top: 10px;
      }
    }
  }
</style>
